import type { Credentials, Registration, Session } from '../api/types';
import type { Messages } from './common';
import {
  ensureErrorMessagesArray,
  ensureBoolean,
  ensureString,
  ensureObject,
  ensureErrorMessagesArrayEmpty
} from './common';
export function notLoggedIn(messages?: Messages) {
  const errorMessages = ensureErrorMessagesArrayEmpty(messages);
  return {
    type: 'NOT_LOGGED_IN',
    errorMessages
  };
}
export function loggedIn(dataValue?: Partial<Session>) {
  const data = ensureObject(dataValue);
  const { name = '', isAdmin = false } = data;
  const nameValue = ensureString(name);
  const isAdminValue = ensureBoolean(isAdmin);
  return {
    type: 'LOGGED_IN',
    name: nameValue,
    isAdmin: isAdminValue
  };
}
export function loggedInUpdate(dataValue?: Partial<Session>) {
  const data = ensureObject(dataValue);
  const { name = '', isAdmin = false } = data;
  const nameValue = ensureString(name);
  const isAdminValue = ensureBoolean(isAdmin);
  return {
    type: 'LOGGED_IN_UPDATE',
    name: nameValue,
    isAdmin: isAdminValue
  };
}
export function refreshLoginStatus() {
  return {
    type: 'REQUEST_LOGGED_IN_UPDATE'
  };
}
export function refreshLoginStatusCancelled() {
  return {
    type: 'REQUEST_LOGGED_IN_UPDATE_CANCELLED'
  };
}
export function cancelRefreshLoginStatus() {
  return {
    type: 'CANCEL_LOGGED_IN_UPDATE'
  };
}

export function userLogoutRequest() {
  return {
    type: 'USER_LOGOUT_REQUEST'
  };
}

export function userLoginRequest(dataParam?: Credentials) {
  const data = dataParam || {};
  return {
    type: 'USER_LOGIN_REQUEST',
    data
  };
}
export function userRegisterRequest(dataParam?: Registration) {
  const data = dataParam || {};
  return {
    type: 'USER_REGISTER_REQUEST',
    data
  };
}
export function notRegistered(messages?: Messages) {
  const errorMessages = ensureErrorMessagesArray(messages);
  return {
    type: 'NOT_REGISTERED',
    errorMessages
  };
}
export function registered() {
  return {
    type: 'REGISTERED'
  };
}
